import { lang } from '@/shared/constants/lang'
import { useStyles } from './styles'
import { SpecialOfferContent } from '@/entities/payments'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'

interface SpecialOfferContentProps extends SpecialOfferContent {
  contentLength: number
}

const imgKeys = 'https://storage.googleapis.com/gamed-games-bucket/pictures/keys.webp'
const imgPlatinum = 'https://storage.googleapis.com/gamed-games-bucket/pictures/platinum.webp'
const imgPlus = 'https://storage.googleapis.com/gamed-games-bucket/pictures/plus.webp'

function matchKindToIcon(kind: number) {
  switch (kind) {
    case 1:
      return imgKeys
    case 2:
      return imgPlus
    case 3:
      return imgPlatinum
    default:
      return undefined
  }
}

export const StarterPackItem = (props: SpecialOfferContentProps) => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.units
  const { kind, amount, contentLength } = props
  const itemIcon = matchKindToIcon(kind)

  if (kind === 1) {
    return (
      <div className={classes.root}>
        <div className={classes.content} data-kind={kind} data-length={contentLength}>
          <img src={itemIcon} style={{ width: '100%' }} alt="" />

          <span className={classes.itemValue}>x{amount}</span>
        </div>

        <div className={classes.itemPriceContainer}>
          <span>{texts.keys}</span>
        </div>
      </div>
    )
  }
  if (kind === 2) {
    return (
      <div className={classes.root}>
        <div className={classes.content} data-kind={kind} data-length={contentLength}>
          <img src={itemIcon} style={{ width: '100%' }} />
        </div>

        <div className={classes.itemPriceContainer}>
          <span style={{ textTransform: 'lowercase' }}>1 {texts.month}</span>
        </div>
      </div>
    )
  }
  if (kind === 3) {
    return (
      <div className={classes.root}>
        <div className={classes.content} data-kind={kind} data-length={contentLength}>
          <img src={itemIcon} />
        </div>

        <div className={classes.itemPriceContainer}>
          <span style={{ textTransform: 'lowercase' }}>1 {texts.year}</span>
        </div>
      </div>
    )
  }
}
